/* src/app/component/system-error/system-error.component.css */
/*# sourceMappingURL=system-error.component-74TX5OUQ.css.map */
